import { ArrowUpRight, Phone } from "lucide-react";
import { SITE } from "@/data/site";

export const BookButton = ({
  label = "Book Online",
  testid = "book-online-btn",
  variant = "solid",
  className = "",
}) => (
  <a
    href={SITE.bookUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className={`group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold transition-[background-color,color,border-color,transform,box-shadow] duration-300 hover:-translate-y-0.5 ${
      variant === "solid"
        ? "bg-brand-red text-white shadow-red hover:bg-brand-redhover"
        : variant === "navy"
          ? "bg-brand-navy text-white hover:bg-brand-navydeep"
          : variant === "light"
            ? "bg-white text-brand-navy hover:bg-slate-100"
            : "border border-slate-300 bg-white text-slate-900 hover:border-slate-900"
    } ${className}`}
  >
    {label}
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </a>
);

export const CallButton = ({
  label = `Call ${SITE.phone}`,
  testid = "call-btn",
  variant = "outline",
  className = "",
}) => (
  <a
    href={SITE.phoneHref}
    data-testid={testid}
    className={`group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold transition-[background-color,color,border-color,transform] duration-300 hover:-translate-y-0.5 ${
      variant === "navy"
        ? "bg-brand-navy text-white hover:bg-brand-navydeep"
        : variant === "light"
          ? "border border-white/30 text-white hover:bg-white/10"
          : "border border-slate-300 bg-white text-slate-900 hover:border-slate-900"
    } ${className}`}
  >
    <Phone className="h-4 w-4" />
    {label}
  </a>
);

export const EmergencyNote = ({ testid = "emergency-note", light = false, className = "" }) => (
  <p
    data-testid={testid}
    className={`flex items-start gap-2 text-xs leading-relaxed ${light ? "text-slate-400" : "text-slate-500"} ${className}`}
  >
    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-red" />
    {SITE.emergencyNote}
  </p>
);
